export default __webpack_public_path__ + "static/media/mama-logo-white.9e7f2cbf.svg";